import cn from 'classnames';
import ProductAddToCartButton from '@components/product/ProductAddToCartButton';
import AddToCartCTA from '_components/Product/AddToCartCTA';
import { FEATURE_FLAG_PDP_2026_1 } from '@config/feature-flag';

import styles from './AddToCartButtonPersistent.module.scss';

const ProductAddToCartButtonPersistent = ({
  isVisible = false,
  prismicDealsBannerTitles = [],
}: {
  isVisible: boolean;
  prismicDealsBannerTitles?: string[];
}) => (
  <div className={cn(styles.container, { [styles.open]: isVisible })}>
    {FEATURE_FLAG_PDP_2026_1 ? (
      <AddToCartCTA prismicDealsBannerTitles={prismicDealsBannerTitles} />
    ) : (
      <ProductAddToCartButton />
    )}
  </div>
);

export default ProductAddToCartButtonPersistent;
